import { TableCell, TableHead, TableRow } from '@mui/material';

import { OrgStatus } from '../../../../../utils/constants';
import React from 'react';
import { t } from 'i18next';

interface Props {
  status: string;
}

/**
 * Renders the table header for the administrator list.
 * Displays columns for status (conditionally), name, and email, with empty cells for actions.
 *
 * @param {Props} props - The component's props.
 * @param {string} props.status - The current status of the organization. The 'Status' column is only shown if the organization is active.
 * @returns {JSX.Element} - The TableHead element containing the header row.
 */
const AdminTableHeader: React.FC<Props> = (props: Props) => {

  return (
    <TableHead>
      <TableRow>
        {(props.status === OrgStatus.Active) &&
          <TableCell>{t('status')}</TableCell>
        }
        <TableCell>{t('name')}</TableCell>
        <TableCell>{t('email')}</TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  );
};

export default AdminTableHeader;